// external imports
import React from 'react'
import { createFragmentContainer, graphql } from 'react-relay'
import { FlexRow, FlexColumn, IconPrinter } from 'quark-web'
// local imports
import { Header, Slideshow, Text, ProductCharacteristics } from '~/components'
import styles from './styles'

const ProductSummaryContent = ({ product }) => (
    <React.Fragment>
        <Header>
            <FlexRow justifyContent="space-between">
                <React.Fragment>
                    {product.category.family && <React.Fragment>{product.category.family.name} – </React.Fragment>}
                    <React.Fragment>{product.category.name} – </React.Fragment>
                    {product.name}
                    <a href={`/print/${product.id}`} target="_blank" style={styles.print}>
                        <span style={{ marginRight: 4 }}>Print</span>
                        <IconPrinter style={styles.icon} />
                    </a>
                </React.Fragment>
            </FlexRow>
        </Header>
        <FlexColumn grow={0}>
            <Slideshow>{product.files.edges.map(({ node }) => node.url)}</Slideshow>
        </FlexColumn>
        <FlexRow shrink={1}>
            <FlexColumn grow={1} shrink={1} style={{ width: 10, marginRight: 50 }}>
                <Text>{product.description.trim()}</Text>
            </FlexColumn>
            <ProductCharacteristics product={product} />
        </FlexRow>
    </React.Fragment>
)

export default createFragmentContainer(
    ProductSummaryContent,
    graphql`
        fragment ProductSummaryContent_product on Product {
            id
            name
            description
            files {
                edges {
                    node {
                        url
                    }
                }
            }
            category {
                name
                family {
                    name
                }
            }
            ...ProductCharacteristics_product
        }
    `
)



// WEBPACK FOOTER //
// ./src/views/Products/ProductSummary/ProductSummaryContent/index.js